import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/layouts/homepage/services/user.service';
import { AuthServerProvider } from 'app/core';
import { SERVER_API_URL } from 'app/app.constants';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-not-allowed-organization',
    templateUrl: './not-allowed-organization.component.html',
    styleUrls: ['../../../../../content/scss/styles.scss']
})
export class NotAllowedOrganizationComponent implements OnInit {
    loading = false;
    public goToUrl: string;
    private subscription: Subscription;

    constructor(private userService: UserService, private authService: AuthServerProvider) {}

    ngOnInit() {
        this.loading = true;

        this.subscription = this.authService.getNotAllowedOrganizationUrl().subscribe(response => {
            this.goToUrl = response.body;
            this.loading = false;
        });
    }

    goToOtherSelfService() {
        window.location.href = this.goToUrl;
    }

    ngOnDestroy() {
        if(this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
